import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import useWebView from "@hooks/useWebview";
import useContactNumbers from "@hooks/useContactNumbers";
import useIsMobile from "@hooks/useIsMobile";
var NeedHelp = function NeedHelp(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    page = _ref.page,
    post_id = _ref.post_id;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var webview = useWebView();
  var isMobile = useIsMobile();
  var contactNumbers = useContactNumbers();
  var border = isMobile ? "" : "border border-solid border-1 border-[#cdd1d4] rounded-[8px]";
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center p-4 w-full max-w-[567px] mx-auto mt-1 ".concat(border, " ").concat(className || "")
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-xl text-center mb-6"
  }, t("want_help", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center w-full gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    id: "precheckout-whatsapp-link",
    className: "flex greenBtn items-center justify-center gap-2 px-4 py-3 !border-none rounded text-white hover:bg-green-600 transition-colors w-64",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: post_id,
        contact_type: "whatsapp",
        contact_location: page
      });
      webview.openUri("https://wa.me/".concat(contactNumbers.whatsappCallNumber))["catch"](function () {
        document.location.href = "https://wa.me/".concat(contactNumbers.whatsappCallNumber);
      });
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-6 h-6",
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "85%"
    }
  }, t("contact_via_whatsapp", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("button", {
    id: "precheckout-call-link",
    className: "flex  bg-[#EBF0F7] items-center justify-center gap-2 px-4 py-3 !border-none rounded text-blue-500 hover:bg-blue-50 transition-colors w-64",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: post_id,
        contact_type: "call",
        contact_location: page
      });
      webview.openUri("tel:".concat(contactNumbers.callCenterCallNumber))["catch"](function () {
        document.location.href = "tel:".concat(contactNumbers.callCenterCallNumber);
      });
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-6 h-6",
    src: CDN_LINK + "/assets/images/Call Us@1Blue.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("call_2", {
    ns: "web_common"
  })))));
};
export default NeedHelp;